const DAYS = Object.freeze([
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
  'holiday',
]);

const DEFAULT_WORK_TIME = {
  open: '08:00:00',
  close: '20:00:00',
};

/**
 * Validate the time in the following format: HH:MM:SS, with mandatory leading 0
 */
const timeRegex = RegExp(/^([0-1]\d|2[0-3]):([0-5]\d):([0-5]\d)$/);

export default class OpeningTimes {
  monday = null;

  tuesday = null;

  wednesday = null;

  thursday = null;

  friday = null;

  saturday = null;

  sunday = null;

  holiday = null;

  areDaysValid() {
    return Object.values(this).some(isDayInvalid);
  }

  constructor(openingTimes = {}) {
    DAYS.forEach(day => {
      if (openingTimes && openingTimes[day]) {
        this[day] = { ...openingTimes[day], isOpen: true };
      } else {
        this[day] = { ...DEFAULT_WORK_TIME, isOpen: false };
      }
    });

    Object.defineProperty(this, 'hasInvalidTimeError', {
      value: this.areDaysValid(),
      enumerable: false,
    });
  }
}

function isDayInvalid({ open, close }) {
  return !timeRegex.test(open) || !timeRegex.test(close);
}



// WEBPACK FOOTER //
// ./src/models/OpeningTimes.js